import React, { useEffect, useState, forwardRef, useImperativeHandle } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { CardContent, FormControlLabel, CardHeader, Card, RadioGroup, Radio, Grid, FormHelperText } from '@material-ui/core'
import { genfunction } from 'helpers';
import { useSelector } from 'react-redux';
import { FormattedInputs } from 'components/InputControls';

const { CouponRemoveMsg } = window['runConfig'];

const useStyles = makeStyles(theme => ({

    tourheaderbox: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        padding: "7px 0px 7px 25px"
    },
    box100per: {
        width: "100%"
    },
    reverseOrder: {
        display: 'flex',
        flexDirection: 'column-reverse'
    }

}));

const PaymentSelection = forwardRef((props, ref) => {

    const classes = useStyles();
    const [errorMsg, seterrorMsg] = useState("");
    const [minDeposit, setMinDeposit] = useState(0);
    const [otherAmount, setOtherAmount] = useState('');

    const bookingTypes = useSelector(state => state.reducerBookingTypes.bookingTypes);
    const bkngType = bookingTypes && bookingTypes.length > 0 ? bookingTypes.filter(x => x.BookingTypeID == props.bookingtypeID)[0] : null;
    const apiData = useSelector(state => state.reducerExtraItems.extraItem);
    const reducerAppLoader = useSelector(state => state.reducerAppLoader.loading);
    const cartEvents = useSelector(state => state.reducerShopCart.events);

    const calculateMinimumDeposit = () => {

        // let MinDeposit = 0;

        // if (apiData && apiData.hasOwnProperty("TourProducts") && apiData.TourEventID === props.toureventID && apiData.TourProducts.filter(x => x.Quantity !== 0 && x.TourProductID !== bkngType.ChaperoneTourProductID).length > 0)
        //     apiData.TourProducts.filter(x => x.Quantity !== 0 && apiData.TourEventID === props.toureventID && x.TourProductID !== bkngType.ChaperoneTourProductID).map((product) => {
        //         MinDeposit += (product.MinDepositPercent * product.ProductTotalAmount) / 100;
        //     })

        // setMinDeposit(MinDeposit);
        // return MinDeposit;

        let minDeposit = genfunction.MinimumDepositCalculation(apiData, props.toureventID, bkngType.ChaperoneTourProductID);
        setMinDeposit(minDeposit);
        return minDeposit;
    }

    useEffect(() => {

        calculateMinimumDeposit();

        if (props.isEditEvent) {
            handleChange(props.paymentOption);
        }

        else {
            bkngType.DefaultToFullPayment ?
                props.onChangePaymentOption("FullPay", apiData.TotalAmount ? apiData.TotalAmount : 0) :
                props.onChangePaymentOption("MinimumPay", calculateMinimumDeposit())

        }

    }, [apiData]);


    useEffect(() => {

        if (props.isEditEvent && reducerAppLoader === false)
            reloadPaymentSelected();

    }, [reducerAppLoader]);


    const reloadPaymentSelected = () => {

        if (cartEvents && cartEvents.length > 0 && cartEvents.find(x => x.TourEventID === props.toureventID)) {
            let cartTourEvent = cartEvents.find(x => x.TourEventID === props.toureventID);

            if (cartTourEvent && cartTourEvent.hasOwnProperty("PaymentOption")) {

                if (cartTourEvent.PaymentOption === "OtherPay")
                    setOtherAmount(cartTourEvent.TotalSelectedAmount);

                props.onChangePaymentOption(cartTourEvent.PaymentOption, cartTourEvent.TotalSelectedAmount);
            }

        }
    }

    useImperativeHandle(ref, () => ({
        validateAmountSelected() {
            if (props.amountSelected === "" || parseFloat(props.amountSelected) < minDeposit || parseFloat(props.amountSelected) > (apiData.TotalAmount ? apiData.TotalAmount : 0)) {
                Validated(false)
                return false;
            }
            else
                return true;
        }
    }));

    const handleOtherPrice = (event) => {
        setOtherAmount(event.target.value);
        props.onChangePaymentOption("OtherPay", event.target.value);
    }

    const Validated = (val) => {
        if (val)
            seterrorMsg('');
        else
            seterrorMsg("Please enter valid amount");
    }

    const checkIsRemoveCoupon = (value) => {

        if (cartEvents && cartEvents.length > 0 && cartEvents.find(x => x.TourEventID === props.toureventID)) {
            let cartTourEvent = cartEvents.find(x => x.TourEventID === props.toureventID);

            if (cartTourEvent && cartTourEvent.hasOwnProperty("PaymentOption")) {

                if (cartTourEvent.PaymentOption !== value && value === "OtherPay" && cartTourEvent.CouponItems.length > 0) {
                    seterrorMsg(CouponRemoveMsg)
                }
            }

        }
    }

    const handleChange = (value) => {

        if (props.isEditEvent) {
            checkIsRemoveCoupon(value);
        }

        if (value === "FullPay") {
            seterrorMsg('');
            setOtherAmount('');
            props.onChangePaymentOption(value, apiData.TotalAmount ? apiData.TotalAmount : 0);

        }
        else if (value === "MinimumPay") {
            seterrorMsg('');
            setOtherAmount('');
            props.onChangePaymentOption(value, calculateMinimumDeposit());

        }
        else if (value === "OtherPay") {
            props.onChangePaymentOption(value, otherAmount)

        }
    }

    return (
        <div>
            <Card style={{ borderRadius: "0" }} className={classes.box100per}>
                <CardHeader className={classes.tourheaderbox}
                    title='Payment Options'
                    titleTypographyProps={{ color: "inherit" }}
                />
                <CardContent>
                    <Grid container xs={12} ms={12} lg={12} style={{ paddingLeft: "15px" }}>

                        <RadioGroup className={classes.box100per} aria-label="grouppayment" name="paymentselectoption" value={props.paymentOption}
                            onChange={({ target: { value } }) => handleChange(value)}>

                            <Grid item xs={12} ms={12} lg={12} className={!bkngType.DefaultToFullPayment ? classes.reverseOrder : ""}  >

                                <FormControlLabel value="FullPay" control={<Radio />} label={"Full Payment - " + genfunction.ccyFormat(apiData.TotalAmount ? apiData.TotalAmount : 0)} />
                                <FormControlLabel value="MinimumPay" control={<Radio />} label={"Minimum Payment - " + genfunction.ccyFormat(minDeposit)} />

                            </Grid>
                            {bkngType.AllowFlexiblePayment ?
                                <Grid container alignItems="center">
                                    <Grid item xs={7} ms={7} lg={7}>

                                        <FormControlLabel value="OtherPay" control={<Radio />} style={{ whiteSpace: "pre-line" }}
                                            label={"Other Amount<br/> Min (".split("<br/>").join("\n") + genfunction.ccyFormat(minDeposit) + ")"}
                                        />

                                    </Grid>

                                    <Grid item xs={5} ms={5} lg={5}>

                                        <FormattedInputs
                                            donaValue={props.paymentOption === "OtherPay" ? otherAmount : null}
                                            minValue={minDeposit}
                                            maxValue={apiData.TotalAmount ? apiData.TotalAmount : 0}
                                            label='Enter amount'
                                            handleOtherPrice={handleOtherPrice}
                                            Validated={Validated}
                                            disabled={props.paymentOption === "OtherPay" ? false : true}
                                            size="small"
                                            variant="outlined"

                                        ></FormattedInputs>

                                        <FormHelperText style={{ color: "Red" }}>{errorMsg}</FormHelperText>

                                    </Grid>
                                </Grid>
                                : null}
                        </RadioGroup>

                    </Grid>
                </CardContent>
            </Card >
        </div >
    )
})

export default PaymentSelection